import { render, staticRenderFns } from "./DocumentConfig.vue?vue&type=template&id=5c0d31b6&scoped=true"
import script from "./DocumentConfig.vue?vue&type=script&lang=js"
export * from "./DocumentConfig.vue?vue&type=script&lang=js"
import style0 from "./DocumentConfig.vue?vue&type=style&index=0&id=5c0d31b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d31b6",
  null
  
)

export default component.exports